<template>
  <el-dialog
      :visible="dialogVisible"
      :title="title"
      :width="width"
      :style="dialogStyle"
      :before-close="close"
      :class="dialogClass"
      @cancel="close"
  >
    <slot name="content"></slot>
    <slot name="footer"></slot>
  </el-dialog>
</template>

<script setup>
import {computed, defineEmits, defineProps} from "vue";
import {useI18n} from "vue-i18n";

const props = defineProps({
  dialogVisible: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: "",
  },
  isHeadLine: {
    type: Boolean,
    default: false,
  },
  width: {
    type: String,
    default: "30%",
  },
});
const emit = defineEmits();
const {t} = useI18n();

const isSystemPrompt = computed(() => props.title === t('sys.team.info'));
const dialogStyle = computed(() => isSystemPrompt.value ? undefined : {minWidth: props.width + 'px'});
const dialogClass = computed(() => [
  props.isHeadLine ? 'headline' : 'noheadline',
  isSystemPrompt.value ? 'system-prompt-dialog' : '',
]);

const close = () => {
  emit("update:dialogVisible")
}
</script>

<style lang="less" scoped>

.el-dialog__title {
  color: rgba(0, 0, 0, .85);
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  word-wrap: break-word;
}

#sendRequire {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

:deep(.el-dialog__body) {
  padding: 60px 20px;
}
</style>
